import { apiRequest } from "../../services/apiService";
import {
  ADD_ROLE_FAIL,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  EDIT_ROLE_FAIL,
  EDIT_ROLE_REQUEST,
  EDIT_ROLE_SUCCESS,
  GET_MODULE_FAIL,
  GET_MODULE_REQUEST,
  GET_MODULE_SUCCESS,
  GET_ROLE_FAIL,
  GET_ROLE_LIST_DATA_FAIL,
  GET_ROLE_LIST_DATA_REQUEST,
  GET_ROLE_LIST_DATA_SUCCESS,
  GET_ROLE_REQUEST,
  GET_ROLE_SUCCESS,
} from "../constant";

export const getRoleList = (data) => {
  return async (dispatch) => {
    dispatch({ type: GET_ROLE_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/roles/getRoleList`,
      data: data,
    });
    if (response) {
      dispatch({ type: GET_ROLE_SUCCESS, payload: response?.data });

      dispatch({ type: GET_ROLE_LIST_DATA_REQUEST, payload: response?.data });
      if (response?.data?.data) {
        const rawData = response?.data?.data;
        dispatch({
          type: GET_ROLE_LIST_DATA_SUCCESS,
          payload: rawData,
        });
      }
    } else if (error) {
      dispatch({ type: GET_ROLE_FAIL });
    }
  };
};

export const getModules = () => {
  return async (dispatch) => {
    dispatch({ type: GET_MODULE_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/roles/getAllModules`,
    });
    if (response) {

      if (response?.data?.data) {
        const rawData = response?.data?.data;
        dispatch({ type: GET_MODULE_SUCCESS, payload: rawData });
      }
    } else if (error) {
      dispatch({ type: GET_MODULE_FAIL });
    }
  };
};

export const addRole = (data) => {
  return async (dispatch) => {
    dispatch({ type: ADD_ROLE_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/roles/addRole`,
      data: data,
    });
    if (response) {
      dispatch({ type: ADD_ROLE_SUCCESS });
    } else if (error) {
      dispatch({ type: ADD_ROLE_FAIL });
    }
  };
};

export const editRole = (data) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_ROLE_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `/roles/updRole`,
      data: data,
    });
    if (response) {
      dispatch({ type: EDIT_ROLE_SUCCESS });
    } else if (error) {
      dispatch({ type: EDIT_ROLE_FAIL });
    }
  };
};

export const deleteRole = (data) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_ROLE_REQUEST });
    const { response, error } = await apiRequest({
      method: "DELETE",
      url: `/roles/delRole`,
      data: data,
    });
    if (response) {
      dispatch({ type: DELETE_ROLE_SUCCESS });
      if (response.data.statusCode === 400) {
        dispatch({ type: DELETE_ROLE_SUCCESS, payload: response.data.msg });
      }
    } else if (error) {
      dispatch({ type: DELETE_ROLE_FAIL });
    }
  };
};
